import styled from 'styled-components';
import { largeWidthScreen, mediumScreens } from 'components/common/fontElements';
import * as colors from '../../../common/colorConstants';

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.black4};
`;

export const SubText = styled.p`
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 9px;
  line-height: 13px;
  color: ${colors.darkGray1};
`;

export const ImageContainer = styled.div`
  height: calc(100% - 70px);
  border-top: 1px solid ${colors.lightGray21};
`;

export const ImageInfoContainer = styled.div`
  padding: 25px 32px 8px;
`;

export const ImagesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 8px 24px;
  height: calc(100% - 70px);
  background-color: ${colors.lightGray7};
`;

export const ImageWrap = styled.div`
  position: relative;
  width: 25%;
  padding: 8px;

  @media screen and (max-width: ${largeWidthScreen}) {
    width: calc(100% / 3);
  }

  @media screen and (max-width: ${mediumScreens}) {
    width: 50%;
  }
`;

export const ImageCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;

  &:checked + label {
    border-color: ${colors.blue1};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(0deg, rgba(74, 144, 226, 0.4), rgba(74, 144, 226, 0.4));
      z-index: 1;
    }

    &::after {
      content: url('/images/checkboxes/circle_checked.svg');
    }
  }
`;

export const ImageLabel = styled.label`
  position: relative;
  margin: 0;
  padding-top: 71.5%;
  width: 100%;
  border: 1px solid ${colors.lightGray1};
  border-radius: 2px;
  overflow: hidden;
  cursor: pointer;
  user-select: none;

  &::after {
    content: url('/images/checkboxes/circle_unchecked.svg');
    position: absolute;
    right: 5px;
    top: 5px;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const InfoIcon = styled.img`
  margin-bottom: 15px;
`;

export const InfoText = styled.p`
  font-weight: 700;
  text-align: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
